import Icon from '../Icon';

const ContestsIcon = (props) => (
    <Icon width='201' height='200' viewBox='0 0 201 200' fill='none' {...props}>
        <g clipPath='url(#clip0_344_28212)'>
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M49.9349 166.467H77.5049V118.995H49.9349V166.467ZM81.2932 174.045H46.1477C44.0552 174.045 42.3594 172.349 42.3594 170.256V115.206C42.3594 113.112 44.0552 111.417 46.1477 111.417H81.2932C83.3847 111.417 85.0804 113.112 85.0804 115.206V170.256C85.0804 172.349 83.3847 174.045 81.2932 174.045Z'
                fill='#FFFDFB'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M85.0794 166.466H115.68V95.5577H85.0794V166.466ZM119.468 174.045H81.2922C79.1997 174.045 77.5039 172.349 77.5039 170.256V91.7683C77.5039 89.6748 79.1997 87.979 81.2922 87.979H119.468C121.56 87.979 123.255 89.6748 123.255 91.7683V170.256C123.255 172.349 121.56 174.045 119.468 174.045Z'
                fill='#FFFDFB'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M123.255 166.467H150.825V142.37H123.255V166.467ZM154.614 174.046H119.468C117.375 174.046 115.68 172.35 115.68 170.257V138.581C115.68 136.498 117.375 134.802 119.468 134.802H154.614C156.705 134.802 158.401 136.498 158.401 138.581V170.257C158.401 172.35 156.705 174.046 154.614 174.046Z'
                fill='#FFFDFB'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M171.591 174.046H29.1672C27.0747 174.046 25.3789 172.35 25.3789 170.257C25.3789 168.163 27.0747 166.467 29.1672 166.467H171.591C173.683 166.467 175.379 168.163 175.379 170.257C175.379 172.35 173.683 174.046 171.591 174.046Z'
                fill='#FFFDFB'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M99.6995 68.5839C100.124 68.364 100.63 68.364 101.056 68.5839L114.825 75.7229L112.202 60.6388C112.117 60.1573 112.28 59.6653 112.633 59.3199L123.727 48.6637L108.374 46.4655C107.896 46.3922 107.481 46.0991 107.265 45.6594L100.378 31.9048L93.4911 45.6594C93.2744 46.0991 92.8588 46.3922 92.3804 46.4655L77.0273 48.6637L88.1211 59.3199C88.4759 59.6653 88.6371 60.1573 88.5534 60.6388L85.9291 75.7229L99.6995 68.5839Z'
                fill='#00D1D2'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M100.381 64.6261C101.213 64.6261 102.045 64.825 102.804 65.2228L109.787 68.8446L108.473 61.2869C108.172 59.5597 108.749 57.8011 110.016 56.5869L115.507 51.3111L107.84 50.212C106.132 49.9712 104.652 48.9035 103.879 47.3543L100.381 40.3723L96.8803 47.3543C96.1099 48.9035 94.6287 49.9712 92.9204 50.212L85.2538 51.3111L90.7494 56.5869C92.0128 57.8011 92.5886 59.5597 92.2881 61.2869L90.9744 68.8446L97.9596 65.2228C98.7174 64.825 99.5486 64.6261 100.381 64.6261ZM114.827 79.5113C114.233 79.5113 113.634 79.3647 113.086 79.0821L100.381 72.4979L87.675 79.0821C86.399 79.7416 84.856 79.6264 83.6931 78.7785C82.5322 77.9202 81.9544 76.4861 82.2014 75.0729L84.6142 61.2032L74.406 51.3949C73.3614 50.3899 72.9803 48.8826 73.4252 47.5008C73.8691 46.1191 75.0603 45.1142 76.4933 44.9153L90.6478 42.8846L96.9934 30.2081C97.6351 28.931 98.9467 28.125 100.381 28.125C101.815 28.125 103.125 28.931 103.768 30.2081L110.113 42.8846L124.268 44.9153C125.701 45.1142 126.891 46.1191 127.336 47.5008C127.78 48.8826 127.399 50.3899 126.355 51.3949L116.147 61.2032L118.56 75.0729C118.807 76.4861 118.228 77.9202 117.067 78.7785C116.405 79.2601 115.619 79.5113 114.827 79.5113Z'
                fill='#FFFDFB'
            />
        </g>
        <defs>
            <clipPath id='clip0_344_28212'>
                <rect width='200' height='200' fill='white' transform='translate(0.378906)' />
            </clipPath>
        </defs>
    </Icon>
);

export default ContestsIcon;
